<section class="solucao-hero">

  <!-- Orbs de fundo -->
  <div class="orb orb-1" [style.background]="selecionado.gradiente"></div>
  <div class="orb orb-2"></div>

  <div class="hero-inner">

    <!-- Topo -->
    <div class="hero-topo">
      <span class="hero-badge">Nossas Soluções</span>
      <h1>Uma plataforma,<br><span>três superpoderes</span></h1>
      <p>Descubra as ferramentas que vão transformar seu departamento contábil</p>
    </div>

    <!-- Showcase -->
    <div class="showcase">

      <!-- Seletor lateral -->
      <div class="selector">
        <div *ngFor="let p of produtos"
             class="selector-item"
             [class.ativo]="selecionado.id === p.id"
             [style.--cor]="p.cor"
             [style.--rgb]="p.corRgb"
             (click)="selecionar(p)">

          <div class="selector-icon">
            <ng-container *ngIf="p.id === 'integra'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
              </svg>
            </ng-container>
            <ng-container *ngIf="p.id === 'neo'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
            </ng-container>
            <ng-container *ngIf="p.id === 'concilia'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
                <line x1="1" y1="10" x2="23" y2="10"/>
              </svg>
            </ng-container>
          </div>

          <div class="selector-info">
            <span class="selector-nome">{{ p.nome }}</span>
            <span class="selector-tag">{{ p.tagline }}</span>
          </div>

          <span class="selector-arrow" *ngIf="selecionado.id === p.id">→</span>
        </div>

        <div class="progresso-wrap">
          <div class="progresso-fill"
               [style.width.%]="progresso"
               [style.background]="selecionado.gradiente"></div>
        </div>
      </div>

      <!-- Painel de detalhe -->
      <div class="showcase-card"
           [class.saindo]="saindo"
           [style.--cor]="selecionado.cor"
           [style.--rgb]="selecionado.corRgb"
           [style.--grad]="selecionado.gradiente">

        <div class="card-icon-wrap">
          <ng-container *ngIf="selecionado.id === 'integra'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
            </svg>
          </ng-container>
          <ng-container *ngIf="selecionado.id === 'neo'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>
          </ng-container>
          <ng-container *ngIf="selecionado.id === 'concilia'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
              <line x1="1" y1="10" x2="23" y2="10"/>
            </svg>
          </ng-container>
        </div>

        <div class="card-body">
          <span class="card-tagline">{{ selecionado.tagline }}</span>
          <h2 class="card-nome">{{ selecionado.nome }}</h2>
          <p class="card-desc">{{ selecionado.descricao }}</p>

          <ul class="card-features">
            <li *ngFor="let f of selecionado.features">
              <span class="feat-check">✓</span>
              {{ f }}
            </li>
          </ul>

          <a href="https://api.whatsapp.com/send/?phone=5548991707731" target="_blank" rel="noopener noreferrer" class="card-cta">
            Falar com especialista <span>→</span>
          </a>
        </div>

      </div>
    </div>
  </div>
</section>

